import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["ref"];
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useRef } from 'react';
import { IconChevronDown } from '@frameio/vapor-icons';
import { usePopover } from '@frameio/vapor';
import { Link } from '../../../utils/helpers';
import { DropdownButton, DropdownMenu, DropdownMenuButton, StyledPopoverContent } from '../../Dropdown';

var DeveloperDropdown = function DeveloperDropdown() {
  var initialFocusRef = useRef();

  var _usePopover = usePopover({
    initialFocusRef: initialFocusRef,
    defaultShowing: false
  }),
      bindTarget = _usePopover.bindTarget,
      bindContent = _usePopover.bindContent;

  var ref = bindTarget.ref,
      bind = _objectWithoutProperties(bindTarget, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownButton, _extends({}, bind, {
    focusRef: ref,
    iconAfter: /*#__PURE__*/React.createElement(IconChevronDown, {
      size: 16
    })
  }), "Developer Tools"), /*#__PURE__*/React.createElement(StyledPopoverContent, _extends({}, bindContent, {
    zIndex: 50
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    ref: initialFocusRef
  }, /*#__PURE__*/React.createElement(Link, {
    to: "https://developer.frame.io/app/tokens",
    alt: "Tokens"
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "Tokens")), /*#__PURE__*/React.createElement(Link, {
    to: "https://developer.frame.io/app/webhooks",
    alt: "Webhooks"
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "Webhooks")), /*#__PURE__*/React.createElement(Link, {
    to: "https://developer.frame.io/app/custom-actions",
    alt: "Custom Actions"
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "Custom Actions")), /*#__PURE__*/React.createElement(Link, {
    to: "https://developer.frame.io/app/oauth-apps",
    alt: "OAuth Apps"
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "OAuth Apps")))));
};

export default DeveloperDropdown;